<template>
    <div class="help-floating dropdown no-arrow tour-topbar-help">
        <a class="btn btn-circle btn-outline bg-white dropdown-toggle"
           role="button" data-bs-toggle="dropdown" aria-expanded="false">
            <i class="fi fi-rr-question"></i>
        </a>
        <ul class="dropdown-menu dropdown-menu-end  animated--grow-in" aria-labelledby="navbarDropdownMenuLink">
            <help-nav></help-nav>

            <li>
                <a class="dropdown-item fs-16 d-inline-flex align-items-center" target="_blank"
                   :href="`https://kidsday.io/${mapLangToLocale(this.lang)}/help`">
                    <i class="fi fi-rr-interrogation me-2 text-gray-700"></i>
                    {{  trans('general.page.get_more_help') }}
                </a>
            </li>
        </ul>
    </div>
</template>

<script>
import HelpNav from "./HelpNav.vue";
import {mapLangToLocale} from "../../services/LocaleServices";

export default {
    name: "HelpButton",
    methods: {mapLangToLocale},
    components: {
        'help-nav': HelpNav
    },
    props: {
        lang: {
            type: String,
            required: false,
            default: 'en'
        }
    },
}
</script>
